import { selectNextBlock } from '@storeOld/reducers/canvas/canvas'
import { nextSymbol } from '@storeOld/reducers/symbolsLibrary/symbolsLibrary'
import { useDispatch, useSelector } from 'react-redux'
import type { Action } from 'redux'
import type { ThunkDispatch } from 'redux-thunk'

import { useArtboardMode } from '@/hooks'
import type { AppState } from '@/types'
import { Keys } from '../keyboard'

const useOnTabKeyboardActions = () => {
  const dispatch = useDispatch<ThunkDispatch<AppState, unknown, Action>>()

  // block selectors
  const selectedBlock = useSelector<AppState, string | null>(
    ({ canvas }) => canvas.block.ids[canvas.block.ids.length - 1]
  )

  const selectedToEditBlock = useSelector<AppState, string | null>(
    ({ canvas }) => canvas.block.selectedToEditBlockId
  )

  // symbol selectors
  const selectedSymbol = useSelector<AppState, string | null>(
    ({ canvas }) => canvas.symbol.selectedSymbol
  )

  const selectedToEditSymbol = useSelector<AppState, string | null>(
    ({ canvas }) => canvas.symbol.selectedToEditSymbol
  )

  // section selectors
  const selectedSection = useSelector<AppState, string | null>(
    ({ canvas }) => canvas.section.selectedSectionId
  )

  const { symbolLibrary } = useArtboardMode()

  const onTabBlock = (event: KeyboardEvent) => {
    event.preventDefault()
    dispatch(selectNextBlock())
  }

  const onTabSymbol = (event: KeyboardEvent) => {
    event.preventDefault()

    // @ts-expect-error
    dispatch(nextSymbol())
  }

  const onTabSection = (event: KeyboardEvent) => {
    event.preventDefault()
  }

  return (event: KeyboardEvent) => {
    if (event.code !== Keys.Tab) {
      return
    }

    if (selectedBlock && !selectedToEditBlock && !symbolLibrary) {
      onTabBlock(event)
    }

    if (selectedSymbol && symbolLibrary && !selectedToEditSymbol) {
      onTabSymbol(event)
    }

    if (selectedSection) {
      onTabSection(event)
    }
  }
}

export default useOnTabKeyboardActions
